import { Dayjs } from "dayjs"
import {
  CalculationItem,
  IPaymentReviewRecordCalc,
} from "./paymentReviewRecordCalc.types"

export class PaymentReviewRecordCalc implements IPaymentReviewRecordCalc {
  constructor(
    public id: number,
    public paymentSchedulePeriodAmount: number,
    public nextPaymentDate: Dayjs,
    public calculationItems: CalculationItem[],
    public accountBalanceApplied?: number,
    public accountBalance?: number,
    public estimateAnnualCost?: number,
    public newMonthlyAmount?: number,
  ) {}

  get getTotalCost() {
    if (!this.newMonthlyAmount) return undefined
    return this.newMonthlyAmount * 12
  }
}
